import Constant from '@/const';
import axios from 'axios';

const getSupplierById = async id => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/master/supplier/${id}`),
    );
    return response.data.data;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default getSupplierById;
